import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { Tooltip } from '@/components/ui/Tooltip'
import { Info } from 'lucide-react'
import { formatDuration, formatInteger, formatPercent } from './formatters'
import type { AISuggestionsPanel } from '@/types/analytics'

interface AiSuggestionsCardProps {
  data: AISuggestionsPanel
}

export function AiSuggestionsCard({ data }: AiSuggestionsCardProps) {
  return (
    <Card className="p-4">
      <CardHeader className="px-0 pb-3">
        <CardTitle className="text-base">AI suggestions</CardTitle>
        <CardDescription>{formatInteger(data.total)} suggested in this range</CardDescription>
      </CardHeader>
      <CardContent className="px-0 space-y-3">
        <div>
          <div className="text-3xl font-semibold tabular-nums text-primary">
            {formatPercent(data.accept_rate, 0)}
          </div>
          <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Accept rate</div>
        </div>
        <ul className="text-xs space-y-1">
          <li className="flex justify-between"><span>Accepted</span><span className="tabular-nums">{formatInteger(data.accepted)}</span></li>
          <li className="flex justify-between"><span>Edited</span><span className="tabular-nums">{formatInteger(data.edited)}</span></li>
          <li className="flex justify-between"><span>Rejected</span><span className="tabular-nums">{formatInteger(data.rejected)}</span></li>
        </ul>
        <div className="pt-2 border-t flex items-center justify-between text-xs">
          <span className="text-muted-foreground flex items-center gap-1">
            Time saved
            <Tooltip content={`Estimated: (accepted + edited) × ${data.seconds_per_accept}s. Tune the multiplier later.`}>
              <Info className="size-3 cursor-help" />
            </Tooltip>
          </span>
          <span className="font-medium tabular-nums">{formatDuration(data.time_saved_seconds)}</span>
        </div>
      </CardContent>
    </Card>
  )
}
